import { issueRptConstants } from '../constants';

export function issueRpt(state = {}, action) {
    switch (action.type) {
        case issueRptConstants.LOADING_REQUEST:
            return {
                ...state,
                loding: action.isbool
            };
        case issueRptConstants.GETALL_REQUEST:
            return {
                ...state,
                loading: true
            };
        case issueRptConstants.GETALL_SUCCESS:
            return {
                ...state,
                items: action.datas
            };
        case issueRptConstants.GETALL_FAILURE:
            return {
                ...state,
                error: action.error
            };
        case issueRptConstants.GETEXPORT_REQUEST:
            return {
                ...state,
                exporting: true
            };
        case issueRptConstants.GETEXPORT_SUCCESS:
            return {
                ...state,
                exportitems: action.datas
            };
        case issueRptConstants.GETEXPORT_FAILURE:
            return {
                ...state,
                error: action.error
            };
        default:
            return state
    }

}